// Lazy Load imagesVideosFilter
const lazyLoadHandler = () => {
  let lazyloadThrottleTimeout;
  const images = document.querySelectorAll('.lazy');

  if (lazyloadThrottleTimeout) {
    clearTimeout(lazyloadThrottleTimeout);
  }

  lazyloadThrottleTimeout = setTimeout(() => {
    const scrollTop = window.pageYOffset;
    Array.prototype.forEach.call(images, (img) => {
      if (img.offsetTop < (window.innerHeight + scrollTop)) {
        img.src = img.dataset.src;
        img.classList.remove('lazy');
      }
    });

    if (images.length === 0) {
      document.removeEventListener('scroll', lazyLoadHandler);
      window.removeEventListener('resize', lazyLoadHandler);
      window.removeEventListener('orientationChange', lazyLoadHandler);
    }
  }, 20);
};

const lazyload = () => {
  if ('IntersectionObserver' in window) {
    const images = document.querySelectorAll('.lazy');

    const options = {
      rootMargin: '0px',
      threshold: 0,
    };

    const imageObserver = new IntersectionObserver((entries) => {
      Array.prototype.forEach.call(entries, (entry) => {
        if (entry.isIntersecting) {
          const image = entry.target;
          image.src = image.dataset.src;
          image.classList.remove('lazy');
          imageObserver.unobserve(image);
        }
      });
    }, options);

    images.forEach((image) => {
      imageObserver.observe(image);
    });
  } else {
    lazyLoadHandler();
    document.addEventListener('scroll', lazyLoadHandler);
    window.addEventListener('resize', lazyLoadHandler);
    window.addEventListener('orientationChange', lazyLoadHandler);
  }
};

export default lazyload;
